import { computed, ref } from 'vue';

export function useReportTableSort(
  rows,
  defaultKey,
  { numericKeys = [] } = {}
) {
  const sortKey = ref(defaultKey);
  const sortDir = ref('desc');
  const searchQuery = ref('');

  const toggleSort = key => {
    if (sortKey.value === key) {
      sortDir.value = sortDir.value === 'desc' ? 'asc' : 'desc';
      return;
    }
    sortKey.value = key;
    sortDir.value = numericKeys.includes(key) ? 'desc' : 'asc';
  };

  const sortedRows = computed(() => {
    const query = searchQuery.value.trim().toLowerCase();
    const filtered = (rows.value || []).filter(row => {
      if (!query) return true;
      return String(row.name || '')
        .toLowerCase()
        .includes(query);
    });

    const key = sortKey.value;
    const direction = sortDir.value === 'desc' ? -1 : 1;
    const numeric = numericKeys.includes(key);

    return [...filtered].sort((left, right) => {
      const leftValue = numeric
        ? Number(left[`sort_${key}`] ?? left[key] ?? 0)
        : String(left[key] || '').toLowerCase();
      const rightValue = numeric
        ? Number(right[`sort_${key}`] ?? right[key] ?? 0)
        : String(right[key] || '').toLowerCase();
      if (leftValue < rightValue) return -1 * direction;
      if (leftValue > rightValue) return 1 * direction;
      return 0;
    });
  });

  return { sortKey, sortDir, searchQuery, toggleSort, sortedRows };
}
